import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700',
    accent: 'bg-accent-100 text-accent-900',
    secondary: 'bg-secondary-100 text-secondary-900',
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索精彩内容
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-lg mx-auto">
            五大内容分类，满足您的所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto rounded-2xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 ${colorMap[cat.color] || 'bg-primary-100 text-primary-700'}`}>
                <i className={`${cat.icon} text-2xl md:text-3xl`} />
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.count.toLocaleString()} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}